// Calculate scroll offset dynamically based on header height
// This ensures consistent spacing regardless of header state (scrolled or not)
const getScrollOffset = (): number => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 140 // Default fallback
  }
  
  const header = document.querySelector('header')
  if (header) {
    const headerHeight = Math.ceil(header.getBoundingClientRect().height)
    const buffer = window.innerWidth >= 1024 ? 36 : 24
    return Math.max(headerHeight + buffer, 120)
  }
  
  return 140 // Default fallback
}

export function scrollToElementWithOffset(element: any) {
  const exists = typeof document !== 'undefined' && typeof window !== 'undefined'
  if (!exists || !element) return

  const offset = getScrollOffset()
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
  const offsetPosition = elementPosition - offset

  window.scrollTo({
    top: Math.max(0, offsetPosition), // Ensure we don't scroll to negative values
    behavior: 'smooth'
  })
}

/**
 * Unified scroll handler that accepts either an element ID (string) or an element directly
 * @param target - Element ID string, Element, or false/null
 */
export function handleScrollTo(target: string | Element | false | null) {
  const exists = typeof document !== 'undefined' && typeof window !== 'undefined'
  if (!exists || !target) return

  let element: Element | null = null

  if (typeof target === 'string') {
    // If it's a string, treat it as an element ID
    element = document.getElementById(target)
  } else if (target instanceof HTMLElement) {
    // If it's already an element, use it directly
    element = target
  }

  if (element) {
    scrollToElementWithOffset(element)
  }
}
